/* eslint-disable */
// Don't check the return type here. This allows `ReturnType<T>` to work
import Colors from '../../Support/Theme/Colors/Colors';
import * as themeConstants from '../../Constants/Theme/Theme.constants';

/**
 * Create styles for `<trucks />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<trucks />` styles
 */
const trucksExpandableSectionStyles = ({ theme }) => {
  const dot = (mainColor) => ({
    fontWeight: 500,
    whiteSpace: `nowrap`,
    color: theme.palette.grey[`500`],
    lineHeight: 1,
    '&::before': {
      content: `''`,
      backgroundColor: mainColor,
      width: 16,
      height: 16,
      borderRadius: 1000,
      display: `inline-block`,
      marginRight: theme.spacing(1) / 2,
      verticalAlign: `text-top`,
    },
  });
  return {
    expansionPanel: {
      backgroundColor: theme.palette.grey[100],
      opacity: 1,
    },
    expansionPanelSummary: {
      display: `block`,
      padding: 0,
      // after update to materialui v4 disabled could not be overwritten simply via classes={{ disabled: ..., expanded: }} etc
      minHeight: `${theme.spacing(1) * 1.5}px !important`,
      margin: `0 !important`,
      opacity: `1 !important`,
      backgroundColor: `${theme.palette.grey[100]} !important`,
    },
    chipTruckIcon: {
      height: 18,
      width: 18,
      color: theme.boralcolorspalette.zambezi[600],
    },
    chipTruck: {
      borderColor: theme.boralcolorspalette.zambezi[600],
      color: theme.boralcolorspalette.zambezi[600],
      paddingLeft: theme.spacing(1) / 2,
    },
    scheduled: {
      backgroundColor: themeConstants.BORAL_GREY,
    },
    inTransit: {
      backgroundColor: themeConstants.BORAL_YELLOW,
      '&:focus,&:hover': {
        backgroundColor: themeConstants.BORAL_YELLOW,
      },
    },
    delivered: {
      backgroundColor: themeConstants.BORAL_GREEN,
      color: `white`,
    },
    borderLeft: {
      borderLeft: `1px solid ${theme.palette.grey[`300`]}`,
      height: `100%`,
      paddingLeft: theme.spacing(1) * 1.5,
      marginLeft: theme.spacing(1) * 1.5,
    },
    loading: {
      color: theme.palette.grey[`500`],
    },
    expandIcon: {
      opacity: 0.4,
      marginTop: 3,
    },
    summary: {
      color: theme.palette.grey[`500`],
    },
    detailsContainer: {
      width: `100%`,
    },
    dotToGo: {
      ...dot(Colors.raven[200]),
    },
    dotInTransit: {
      ...dot(themeConstants.BORAL_YELLOW),
    },
    dotDelivered: {
      ...dot(themeConstants.BORAL_GREEN),
    },
    dotPlusLoad: {
      ...dot(Colors.raven[500]),
    },
    timeLapseIcon: {
      marginLeft: 8,
      fontSize: 18,
      color: theme.palette.grey[`900`],
    },
    docketIcon: {
      height: theme.spacing(1) * 2,
      position: `relative`,
      top: 4,
      marginRight: theme.spacing(1) / 2,
    },
    docketWithIcon: {
      fontWeight: 500,
      textDecoration: `underline`,
    },
    scheduledLoad: {
      marginBottom: theme.spacing(1) * 1.5,
    }
  };
};

export default trucksExpandableSectionStyles;
